export default __webpack_public_path__ + "static/media/DNo.2-1.4bed9538.jpg";